import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpHandler,
    HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable()
export class LanguageParamInterceptor implements HttpInterceptor {
    private currentPath = '';

    constructor(private router: Router) {
        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe(() => {
                this.currentPath = this.router.url;
            });
    }

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler,
    ): Observable<HttpEvent<any>> {
        if (req.url.includes('apiv2.clico.com.mx')) {
            return next.handle(req);
        }
        if (this.currentPath.startsWith('/en')) {
            const modifiedReq = req.clone({
                params: req.params.set('language', 'EN'),
            });
            return next.handle(modifiedReq);
        } else {
            const modifiedReq = req.clone({
                params: req.params.set('language', 'ES'),
            });
            return next.handle(modifiedReq);
        }
    }
}
